import { useEffect, useState } from "react";
import { BrandMark } from "@/components/BrandMark";

const STEPS = [
  "Finding real places near your starting point…",
  "Matching them to your taste profile…",
  "Mixing in free and low-cost spots…",
  "Timing the route between stops…",
  "Writing why each stop fits you…",
];

export const GeneratingOverlay = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % STEPS.length), 4500);
    return () => clearInterval(t);
  }, []);
  return (
    <div data-testid="generating-overlay" className="fixed inset-0 z-[1300] bg-[#F3F6EF]/80 backdrop-blur-md flex items-center justify-center p-6">
      <div className="bg-white rounded-3xl border border-stone-200 shadow-xl p-8 max-w-sm w-full text-center rise">
        <BrandMark size={72} className="mx-auto animate-bounce" />
        <h3 className="mt-5 text-xl font-bold text-stone-900">Building your outing</h3>
        <p key={i} className="mt-2 text-sm text-stone-600 rise" data-testid="generating-step">{STEPS[i]}</p>
        <div className="mt-5 h-1.5 bg-stone-100 rounded-full overflow-hidden">
          <div className="h-full bg-[#2F7D55] rounded-full transition-[width] duration-[4500ms] ease-linear" style={{ width: `${((i + 1) / STEPS.length) * 100}%` }} />
        </div>
        <p className="mt-4 text-xs text-stone-400">Usually 20–60 seconds. Then put the phone away and go.</p>
      </div>
    </div>
  );
};
